"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _WaitForData = _interopRequireDefault(require("../../../../../../WaitForData"));
var _Panel = _interopRequireDefault(require("../../Panel"));
var _List = _interopRequireDefault(require("../List"));
const Main = _ref => {
  let {
    onClose,
    announcements
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Panel.default, {
    section: "announcements",
    text: "Announcements.Title",
    onClose: onClose
  }, /*#__PURE__*/_react.default.createElement(_WaitForData.default, {
    queryResult: announcements,
    noContent: "Announcements.NoAnnouncements",
    failedInitial: "Announcements.LoadError",
    passRefetch: false
  }, _ref2 => {
    let {
      data
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      items: data.announcements
    });
  }));
};
var _default = exports.default = Main;